var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",on:{"click":function($event){_vm.changeNum++}}},[_c('navBar'),_c('router-view'),_c('sideBar',{attrs:{"changeNum":_vm.changeNum}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }